"use client";

/**
 * ResolutionPath — small breadcrumb showing the walk so users see *why*
 * they're being asked to pick a contact when they clicked SMS on a deal.
 */

import type { WalkPath } from "@/lib/actions/relationships/types";

interface Props {
  walk: WalkPath | null;
}

export function ResolutionPath({ walk }: Props) {
  if (!walk || walk.steps.length === 0) return null;
  const labels = [
    capitalize(walk.source),
    ...walk.steps.map((s) =>
      s.kind === "edge" ? s.edge.label : s.edge.label,
    ),
  ];
  return (
    <div className="text-xs text-muted-foreground">
      {labels.join(" → ")}
    </div>
  );
}

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
